import * as React from "react";
const Arrow = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 6.19526C3.78886 5.93491 4.21097 5.93491 4.47132 6.19526L7.99992 9.72386L11.5285 6.19526C11.7889 5.93491 12.211 5.93491 12.4713 6.19526C12.7317 6.45561 12.7317 6.87772 12.4713 7.13807L8.94273 10.6667C8.42203 11.1874 7.57781 11.1874 7.05711 10.6667L3.52851 7.13807C3.26816 6.87772 3.26816 6.45561 3.52851 6.19526Z" fill="#485476" />
    </svg>
);
export default Arrow;